/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePrivacyRequestsForBackfillRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CreatePrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const createPrivacyRequestsForBackfill = (request:CreatePrivacyRequestsForBackfillRequest, options?: CashRequestOptions) => post<CreatePrivacyRequestsForBackfillRequest, CreatePrivacyRequestResponse>("/2.0/cash/create-privacy-requests-for-backfill", request, {...options, rejectOnError: true })